var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgCollapse = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0.00 0.00 256.00 256.00",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    id: "arrow_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.99,48.41 L133.99,85.45 L111.95,63.40",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeWidth: 11.12,
    strokeOpacity: 1,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.99,85.45 L154.86,64.58",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeWidth: 11.12,
    strokeOpacity: 1,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.28,218.17 L132.28,181.14 L110.24,203.18",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeWidth: 11.12,
    strokeOpacity: 1,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.28,181.14 L153.15,202.00",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeWidth: 11.12,
    strokeOpacity: 1,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.54,111.31 L55.22,111.31",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeWidth: 17.11,
    strokeOpacity: 1,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.54,158.37 L55.22,158.37",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeWidth: 17.11,
    strokeOpacity: 1,
    strokeLinejoin: "round"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCollapse, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/collapse.e8abb1c7.svg";
export { ForwardRef as ReactComponent };